import {
  createFileRoute,
  stripSearchParams,
  useNavigate,
  useSearch,
} from '@tanstack/react-router'
import { fallback, zodValidator } from '@tanstack/zod-adapter'
import { useEffectOnce } from 'react-use'
import { z } from 'zod'

import { queryClient } from '@/api/api'
import { assignTaskToUserOptions } from '@/api/codegen/@tanstack/react-query.gen'
import { useAssignedTaskById } from '@/api/domain/task/task'
import { Loading } from '@/components/ui/Loading'
import { useSidebar } from '@/components/ui/Sidebar'
import { SidebarKeyMap } from '@/constants/sidebar.constants'
import { TaskBasicPage } from '@/pages/task-basic/TaskBasic.page'

const TaskPageContainer = () => {
  const { annotationId, projectId } = useSearch({ from: '/_auth/task-qc' })
  const { setOpen } = useSidebar(SidebarKeyMap.MAIN)
  const navigate = useNavigate()
  const {
    data: task,
    isFetching,
    isPending,
    isError,
  } = useAssignedTaskById({
    projectId,
    annotationId,
  })

  // close sidebar on mount and open it on unmount
  useEffectOnce(() => {
    setOpen(false)

    return () => {
      setOpen(true)
      queryClient.removeQueries({
        queryKey: assignTaskToUserOptions().queryKey,
      })
    }
  })

  if (isFetching || isPending) {
    return <Loading />
  }

  if (isError) {
    navigate({
      to: '/dashboard',
    })

    return null
  }

  // if (task.type === 'video_annotation') {
  //   return (
  //     <TaskVideoAnnotationPage
  //       task={task}
  //       isNewTaskModalEnable={true}
  //       isTaskQC
  //     />
  //   )
  // }

  return <TaskBasicPage task={task} isNewTaskModalEnable isTaskQC />
}

const DEFAULT_SEARCH = {
  projectId: '',
  annotationId: '',
} as const

const SEARCH_SCHEMA = z.object({
  projectId: fallback(z.string(), DEFAULT_SEARCH.projectId).default(
    DEFAULT_SEARCH.projectId,
  ),
  annotationId: fallback(z.string(), DEFAULT_SEARCH.annotationId).default(
    DEFAULT_SEARCH.annotationId,
  ),
})

export const Route = createFileRoute('/_auth/task-qc')({
  beforeLoad: () => {
    // TODO: we should check if the user has access to the task
  },
  component: TaskPageContainer,
  loader: () => ({ breadcrumbTitle: 'Task QC' }),
  validateSearch: zodValidator(SEARCH_SCHEMA),
  search: {
    middlewares: [stripSearchParams(DEFAULT_SEARCH)],
  },
})
